jQuery(document).ready(function($){
    $('.custom_fancybox').fancybox({
        caption: function(instance, item){
            if ($(this).find('.fancybox_caption').html() != 'undefined'){
                return $(this).find('.fancybox_caption').html()
            }
        },
        hash: false
    });
});